import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBAPI from '@/util/SBAPI';
import SBArtistListCategoryIcon from './SBArtistListCategoryIcon.vue';


@Component({
    components: {
        SBArtistListCategoryIcon,
    }
})
export default class SBArtistListTitle extends Mixins(SBComponentVue) {
    @Prop({
        type: Object,
        default: () => { return { "slug": "aoi", "icon": "https://placehold.jp/150x150.png", "type": "YTUBER", "description": "ふじあおいふじあおいふじあおいふじあおいふじあおいふじあおいふじあおいふじあおいふじあおい" } }
    })
    artist!: SBAPI.Artist;

    @Prop({
        type: Boolean,
        default: false
    })
    endArtist!: boolean;
}
